module.exports = __webpack_public_path__ + "img/good-6.3c1cff73.png";